import React from 'react';
import { injectIntl } from 'react-intl';

import { useLanguage } from '../hooks/useLanguage';
import { useDataLayer } from '../hooks/useDataLayer';

import ButtonNativeElement from './ButtonNativeElement';
import AnchorNativeElement from './AnchorNativeElement';
import Icon from './Icon';

const components = {
  anchor: AnchorNativeElement,
  button: ButtonNativeElement
};

function Button({
  button = {},
  children,
  intl,
  isDisabled,
  isActive,
  onClick
}) {
  const {
    version,
    label,
    formattedLabel,
    ariaLabel,
    icon,
    iconPosition,
    additionalClassNames,
    externalLink,
    href,
    dataLayer,
    identifier
  } = button;

  const LabelHtml = () => (
    <>
      {formattedLabel && (
        <div
          dangerouslySetInnerHTML={{
            __html: formattedLabel?.childMarkdownRemark?.html
          }}
        />
      )}
    </>
  );

  const { pushCustomEvent } = useDataLayer();

  const getButtonType = () => (externalLink || href ? 'anchor' : 'button');

  const ariaLabelText = ariaLabel
    ? ariaLabel
    : label?.props?.id
    ? intl.formatMessage({ id: label.props.id })
    : label;

  const style = `btn --${version}  ${additionalClassNames || ''} ${
    isDisabled ? '--disabled' : ''
  } ${isActive ? '--active' : ''} `;

  const ButtonLabel = () => (
    <>
      {children || label || <LabelHtml /> || null}
      {icon && <Icon icon={icon} additionalClassNames={`--${iconPosition}`} />}
    </>
  );

  const ButtonComponent = components[getButtonType()];
  return (
    <>
      {ButtonComponent && (
        <ButtonComponent
          button={button}
          style={style}
          ariaLabel={ariaLabelText}
          disabled={isDisabled}
          onClick={() => {
            if (dataLayer) {
              // Get string label either from contentful dataLayer object or from text label
              const dataLayerLabel = dataLayer.label || ariaLabelText;
              const action = `${dataLayer.action}${
                identifier ? ` ${identifier}` : ''
              }`;
              const { category } = dataLayer;
              pushCustomEvent(category, action, dataLayerLabel);
            }
            if (onClick) {
              onClick();
            }
            return;
          }}
        >
          <ButtonLabel />
        </ButtonComponent>
      )}
    </>
  );
}

export default injectIntl(Button);
